export const COLOR_7P_DARK_GRAY = '#2F373A';
export const COLOR_7P_CYAN = '#1AB0AF';
export const COLOR_7P_TEAL = '#0E6362';
